module.exports = __webpack_public_path__ + "static/media/note-detail.54973e20.png";